import { useEffect, useState } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Header from "./sections/Header";
import HeroSlider from "./sections/HeroSlider";
import BrandIntro from "./sections/BrandIntro";
import BestSellers from "./sections/BestSellers";
import Collection from "./sections/Collection";
import BoutiqueExperience from "./sections/BoutiqueExperience";
import Reviews from "./sections/Reviews";
import StoreLocations from "./sections/StoreLocations";
import HowToOrder from "./sections/HowToOrder";
import FAQ from "./sections/FAQ";
import Footer from "./sections/Footer";
import CartDrawer from "./sections/CartDrawer";
import MobileStickyCTA from "./sections/MobileStickyCTA";
import { SITE } from "./data/site";

function App() {
  const [cartOpen, setCartOpen] = useState(false);

  useEffect(() => {
    document.title = SITE.metaTitle;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = SITE.metaDesc;

    // LocalBusiness / ClothingStore structured data
    const ld = {
      "@context": "https://schema.org",
      "@type": "ClothingStore",
      name: SITE.brand,
      description: SITE.metaDesc,
      image: `${window.location.origin}/images/hero/triple-j-bali-hero-lifestyle-01.webp`,
      url: window.location.origin,
      telephone: SITE.whatsappNumberDisplay,
      sameAs: [SITE.instagram],
      openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
        opens: "09:00",
        closes: "21:00",
      },
      location: [
        { "@type": "Place", name: "Triple J Bali — Canggu Store", hasMap: SITE.cangguMaps, address: { "@type": "PostalAddress", addressLocality: "Canggu", addressRegion: "Bali", addressCountry: "ID" } },
        { "@type": "Place", name: "Triple J Bali — Ubud Store", hasMap: SITE.ubudMaps, address: { "@type": "PostalAddress", addressLocality: "Ubud", addressRegion: "Bali", addressCountry: "ID" } },
      ],
    };
    let s = document.getElementById("tjb-ldjson");
    if (!s) {
      s = document.createElement("script");
      s.type = "application/ld+json";
      s.id = "tjb-ldjson";
      document.head.appendChild(s);
    }
    s.textContent = JSON.stringify(ld);
  }, []);

  return (
    <div className="App bg-[hsl(var(--background))]">
      <Header onOpenCart={() => setCartOpen(true)} />
      <main>
        <HeroSlider />
        <BrandIntro />
        <BestSellers />
        <Collection />
        <BoutiqueExperience />
        <Reviews />
        <StoreLocations />
        <HowToOrder />
        <FAQ />
      </main>
      <Footer />
      <MobileStickyCTA onOpenCart={() => setCartOpen(true)} />
      <CartDrawer open={cartOpen} onOpenChange={setCartOpen} />
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
